import Gantt from './Gantt';
export default Gantt;


// WEBPACK FOOTER //
// ./components/Gantt/index.js